import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { API_BASE_URL } from "../config";
import useUser from "../hooks/useUser";

export default function Login() {
  const navigate = useNavigate();
  const { login } = useUser();

  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const res = await fetch(`${API_BASE_URL}/api/users/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });

      const text = await res.text();
      let data;
      try {
        data = JSON.parse(text);
      } catch {
        throw new Error("Server returned an unexpected response. Please try again.");
      }

      if (!res.ok) throw new Error(data?.message || "Login failed.");

      // Save token + user
      login(data.user, data.token);

      navigate("/", { replace: true });
    } catch (err) {
      setError(err.message || "Something went wrong.");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="max-w-md mx-auto mt-10 bg-white rounded-2xl border shadow-soft overflow-hidden">
      <div className="bg-brand-100 px-6 py-5 border-b border-brand-200">
        <h1 className="text-2xl font-bold text-ink">Log in</h1>
        <p className="text-ink/70 text-sm">Access resources and manage your account.</p>
      </div>

      <form onSubmit={handleSubmit} className="p-6 grid gap-4">
        {error && (
          <div role="alert" className="rounded-lg border border-red-300 bg-red-50 text-red-700 p-3">
            {error}
          </div>
        )}

        <div className="grid gap-1">
          <label className="text-sm font-medium" htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            required
            className="rounded-xl border px-3 py-2 w-full"
            value={form.email}
            onChange={(e) => setForm((f) => ({ ...f, email: e.target.value }))}
          />
        </div>

        <div className="grid gap-1">
          <label className="text-sm font-medium" htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            required
            className="rounded-xl border px-3 py-2 w-full"
            value={form.password}
            onChange={(e) => setForm((f) => ({ ...f, password: e.target.value }))}
          />
        </div>

        <button
          type="submit"
          disabled={loading}
          className="rounded-xl bg-brand-600 text-white font-medium px-4 py-2 hover:bg-brand-700 disabled:opacity-60"
        >
          {loading ? "Logging in..." : "Log in"}
        </button>

        <p className="text-sm text-ink/70">
          Don’t have an account?{" "}
          <Link to="/register" className="text-ink font-medium underline">
            Register
          </Link>
        </p>
      </form>
    </div>
  );
}
